import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@/shared/ui';
import { TableCell } from './TableCell';
import { TableRow } from './TableRow';

type TableEmptyRowProps = {
  colSpan: number;
  showLastBorderBottom: boolean;
  emptyRender?: ReactNode;
};

/**
 * データがない場合の空状態行をレンダリングするコンポーネント
 */
export const TableEmptyRow = ({
  colSpan,
  showLastBorderBottom,
  emptyRender,
}: TableEmptyRowProps) => {
  const { t } = useTranslation();

  return (
    <TableRow className={showLastBorderBottom ? '' : 'border-b-0'}>
      <TableCell colSpan={colSpan} className="h-24 text-center">
        {/*
          空状態は常に中央寄せで表示する。呼び出し側（emptyRender）は中身（メッセージ・
          タイトル + 説明・CTA・アイコン等）だけを渡せばよく、横方向の中央寄せ用ラッパーは
          ここで一元的に付与する。複数要素を縦並びにしたい場合のみ、emptyRender 側で
          `flex flex-col items-center gap-N` を指定する。
        */}
        <div className="flex w-full items-center justify-center">
          {emptyRender ?? <Text>{t('common.table.no-data')}</Text>}
        </div>
      </TableCell>
    </TableRow>
  );
};
